import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-upload-input',
  templateUrl: './upload-input.component.html',
  styleUrls: ['./upload-input.component.scss']
})
export class UploadInputComponent implements OnInit {


  @Input() legend: string;
  @Input() accept: string;
  @Output() emitFile = new EventEmitter();
  nameFile = 'Selecione o Arquivo';
  model: any;

  constructor() { }

  ngOnInit() {
  }
  changeInput(e) {

    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

    if (file) {
      this.nameFile = file.name;
      const reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsDataURL(file);
    } else {
      this.nameFile = 'Selecione o Arquivo';
    }

  }

  _handleReaderLoaded(e) {
    const reader = e.target;
    const valueBase = reader.result;
    this.emitFile.emit(valueBase);
    console.log(valueBase);

  }

}
